import React from 'react'

export default function LoaderSponsorDetails() {
  return (
    <div className="border-2 border-muted-500 bg-white p-2">
      <form className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex flex-col gap-1">
            <div className={`relative h-64 w-64 border-2 border-muted-500`}>
              <div className="h-full w-full object-contain"></div>
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <div
              className={`relative h-64 w-64 w-full border-2 border-muted-500`}
            >
              <div className="h-full w-full object-contain"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-3 py-2 leading-none outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>

          <div className="flex w-full flex-col gap-1">
            <input
            disabled
              type="text"
              className="bg-white border-2 border-muted-500 px-4 py-2 leading-none outline-none"
            />
          </div>
        </div>

        <div className="flex w-full flex-col gap-1">
          <input
          disabled
            type="text"
            className="bg-white h-[150px] border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <input
          disabled
            type="text"
            className="bg-white h-[150px] border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
      </form>
    </div>
  )
}
